import { IonChip, IonIcon } from "@ionic/react";
import React, { useEffect, useState } from "react";
import { useArtists } from "../data/store/useArtists";
import { ArtistService } from "../services/ArtistService";
import { closeOutline } from "ionicons/icons";

interface inviteChipParams {
  email: string;
  showDeleteIcon?: boolean;
  onClick?: () => void;
}

export const GroupInviteChip: React.FC<inviteChipParams> = ({
  showDeleteIcon = false,
  email,
  onClick = () => {},
}) => {
  const authorId = ArtistService.calculateArtistId(email);
  const cachedArtist = useArtists((x) => x.retrieve(authorId));
  const [artistExists, setArtistExists] = useState<boolean | null>(
    cachedArtist ? true : null
  );

  useEffect(() => {
    if (cachedArtist) {
      setArtistExists(true);
      return;
    }
    let cancelled = false;
    ArtistService.fetch(authorId)
      .then(() => { if (!cancelled) setArtistExists(true); })
      .catch(() => { if (!cancelled) setArtistExists(false); });
    return () => { cancelled = true; };
  }, [authorId, cachedArtist]);

  // Default to "warning" while loading so the visual matches old behavior
  // for unknown artists.
  const color = artistExists ? "favorite" : "warning";

  return (
    <IonChip onClick={onClick} color={color}>
      {showDeleteIcon && (
        <IonIcon color="dark" icon={closeOutline} style={{ margin: 0 }} aria-hidden="true" />
      )}
      {email}
    </IonChip>
  );
};

export default GroupInviteChip;
